import * as React from 'react';
import LockIcon from './icons/LockIcon';
import injectSheet from 'react-jss';

const styles = ({
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    background: '#fff',
    marginTop: '15%',
  },
  lockIcon: {
    fontSize: 104,
  },
  title: {
    paddingTop: 20,
    color: '#262626',
    fontSize: 28,
    fontWeight: 600,
  },
  subTitle: {
    fontSize: 16,
    color: '#262626',
    paddingTop: 8,
  },
});
class UnauthorizedAccess extends React.PureComponent<any, any>{
  render() {
    const { classes } = this.props;
    return <div className={classes.flexBox}>
      <LockIcon className={classes.lockIcon}></LockIcon>
      <div className={classes.title}>OOPS!</div>
      <div className={classes.subTitle}>You don't have the necessary access to the page</div>
    </div>;
  }
}

export default injectSheet(styles)(UnauthorizedAccess);
